var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { DefaultIntegrationImportErrorsParams, DefaultIntegrationImportParams } from './integration-imports.interface';
import { GET_INTEGRATION_IMPORT_ERRORS_SUCCESS, GET_INTEGRATION_IMPORTS_SUCCESS, SET_INTEGRATION_IMPORT_ERRORS_PARAMS, SET_INTEGRATION_IMPORTS_PARAMS } from './integration-imports.actions';
export var importsInitialState = {
    data: {
        data: [],
        total: 0
    },
    params: new DefaultIntegrationImportParams()
};
export var importErrorsInitialState = {
    data: {
        data: [],
        total: 0
    },
    params: new DefaultIntegrationImportErrorsParams(null)
};
export function integrationImportsReducer(state, action) {
    if (state === void 0) { state = importsInitialState; }
    switch (action.type) {
        case GET_INTEGRATION_IMPORTS_SUCCESS:
            return __assign({}, state, { data: action.payload });
        case SET_INTEGRATION_IMPORTS_PARAMS:
            return __assign({}, state, { params: action.payload });
        default: {
            return state;
        }
    }
}
export function integrationImportErrorsReducer(state, action) {
    if (state === void 0) { state = importErrorsInitialState; }
    switch (action.type) {
        case GET_INTEGRATION_IMPORT_ERRORS_SUCCESS:
            return __assign({}, state, { data: action.payload });
        case SET_INTEGRATION_IMPORT_ERRORS_PARAMS:
            return __assign({}, state, { params: action.payload });
        default: {
            return state;
        }
    }
}
export var integrationImportReducers = {
    integrationImports: integrationImportsReducer,
    integrationImportErrors: integrationImportErrorsReducer
};
export var getIntegrationImports = function (state) { return state.integrationImports; };
export var getIntegrationImportsData = function (state) {
    return state.integrationImports.data;
};
export var getIntegrationImportsParams = function (state) {
    return state.integrationImports.params;
};
export var getIntegrationImportsDataSelector = createSelector(getIntegrationImports, getIntegrationImportsData);
export var getIntegrationImportsParamsSelector = createSelector(getIntegrationImports, getIntegrationImportsParams);
export var getIntegrationImportErrorsData = function (state) {
    return state.integrationImportErrors.data;
};
export var getIntegrationImportErrorsParams = function (state) {
    return state.integrationImportErrors.params;
};
export var getIntegrationImportErrorsDataSelector = createSelector(getIntegrationImports, getIntegrationImportErrorsData);
export var getIntegrationImportErrorsParamsSelector = createSelector(getIntegrationImports, getIntegrationImportErrorsParams);
